import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

let uri = process?.env?.REACT_APP_JOB_SCHEDULE_PROXY_URL || 'https://service-proxy.dev.embrix.org/graphql';

if (window._env_ && window._env_.REACT_APP_JOB_SCHEDULE_PROXY_URL) {
  uri = window._env_.REACT_APP_JOB_SCHEDULE_PROXY_URL;
}

// Security #1: service-proxy now requires auth. Attach the bearer token stored
// at login (same token used by the main Apollo client).
const authLink = new ApolloLink((operation, forward) => {
  const token =
    typeof window !== 'undefined' && window.localStorage
      ? window.localStorage.getItem('authToken')
      : null;
  operation.setContext(({ headers = {} }) => ({
    headers: token ? { ...headers, Authorization: `Bearer ${token}` } : headers,
  }));
  return forward(operation);
});

const customFetch = (input, init) =>
  fetch(input, init).then(response => {
    if (response.status === 401) {
      if (window.localStorage) window.localStorage.removeItem('authToken');
      if (window.location && window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return response;
  });

const httpLink = new HttpLink({ uri, fetch: customFetch });

const jobSchedule = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions,
});

export default jobSchedule;
